import { OcppCommandType } from './ocpp-command-type';

export class OcppCommandTypeItem {
    constructor(ocppCommandType: OcppCommandType, ocppCommandTypeText: string, ocppCommandTypeVendor: string = '') {
        this.ocppCommandType = ocppCommandType;
        this.ocppCommandTypeText = ocppCommandTypeText;
        this.ocppCommandTypeVendor = ocppCommandTypeVendor;
    }

    ocppCommandType: OcppCommandType;
    ocppCommandTypeText: string;
    ocppCommandTypeVendor: string;
}
